// extracted by mini-css-extract-plugin
export default {"socials":"SocialIcons_socials__VzVF7","icon":"SocialIcons_icon__-3hoT"};